import { jsx } from "react/jsx-runtime";
import { Divider } from "@mui/material";
import { useTexts } from "./useTexts.js";
function LoginFormDivider() {
  const texts = useTexts();
  return /* @__PURE__ */ jsx(Divider, { children: texts.divider });
}
export {
  LoginFormDivider
};
//# sourceMappingURL=LoginFormDivider.js.map
